// extracted by mini-css-extract-plugin
module.exports = {"progressWrapper":"CircularProgressBar_progressWrapper__NfIuN","text":"CircularProgressBar_text__Ws5PM"};